import styles from './Toggle.module.scss'

const Toggle = ({
  label,
  disabled = false,
  id,
  className,
  labelClass,
  checked,
  handleChange,
  name,
  isGray = true,
  isEditable = true,
  forwardedRef,
  mini
}) => (
  <label htmlFor={id} className={[className, styles.label].join(' ')}>
    {isEditable && (
      <>
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={checked}
          id={id}
          onChange={handleChange}
          name={name}
          disabled={disabled}
          ref={forwardedRef}
        />
        <div
          className={[
            isGray ? styles.toggleGray : styles.toggle,
            mini ? styles.mini : ''
          ].join(' ')}
        >
          <div className={styles.togglePill}></div>
        </div>
      </>
    )}
    <span className={labelClass}>{label}</span>
  </label>
)

export default Toggle
